export default __webpack_public_path__ + "static/media/504.d9df68f6.png";